import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { SERVICES, waLink } from "../../data";
import { Reveal } from "./Reveal";

export const Services = () => (
  <section
    id="servizi"
    className="relative mx-auto max-w-6xl px-5 py-24 sm:py-32"
    data-testid="services-section"
  >
    <Reveal>
      <p className="mb-3 text-sm font-semibold uppercase tracking-[0.2em] text-[#FFC400]">
        / I nostri servizi
      </p>
      <h2 className="max-w-2xl font-display text-3xl font-extrabold tracking-tighter text-white sm:text-5xl">
        Soluzioni elettriche complete, per ogni esigenza.
      </h2>
    </Reveal>

    <div className="mt-14 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
      {SERVICES.map((s, i) => (
        <Reveal key={s.title} delay={(i % 4) * 0.08}>
          <motion.a
            href={waLink(`Salve ELETTRIKPRO, vorrei informazioni sul servizio: ${s.title}.`)}
            target="_blank"
            rel="noopener noreferrer"
            whileHover={{ y: -6 }}
            transition={{ type: "spring", stiffness: 300, damping: 20 }}
            className="group flex h-full flex-col rounded-2xl border border-white/10 bg-white/[0.03] p-6 transition-colors duration-300 hover:border-[#FFC400]/50"
            data-testid={`service-card-${i}`}
          >
            <div className="mb-5 flex items-center justify-between">
              <span className="grid h-12 w-12 place-items-center rounded-xl bg-[#FFC400]/10 text-[#FFC400] transition-colors duration-300 group-hover:bg-[#FFC400] group-hover:text-[#0B1F3A]">
                <s.icon className="h-6 w-6" strokeWidth={2.2} />
              </span>
              <ArrowUpRight className="h-5 w-5 text-white/20 transition-all duration-300 group-hover:text-[#FFC400] group-hover:rotate-0" />
            </div>
            <h3 className="font-display text-lg font-bold leading-tight text-white">
              {s.title}
            </h3>
            <p className="mt-2 text-sm text-white/60">{s.desc}</p>
          </motion.a>
        </Reveal>
      ))}
    </div>
  </section>
);

export default Services;
